import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/panxo/Development/LigasDeportivas/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/panxo/Development/LigasDeportivas/web/src/styles/globals.css");
